module.exports = ".message {\n  margin: 15px 15px; }\n  .message h1 {\n    color: #555;\n    font-weight: bold;\n    font-size: 17px;\n    line-height: 20px;\n    text-align: center;\n    width: 100%; }\n  .message p {\n    font-size: 12px;\n    line-height: 16px;\n    margin-bottom: 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home-comments/home-comments.component.scss
// module id = ./src/app/components/home/home-comments/home-comments.component.scss
// module chunks = main